import { Controller } from "stimulus";

export default class extends Controller {
	static targets = ['checkSendToSign'];

  connect() {
		if (!this.hasCheckSendToSignTarget)
			return;

		this.checkSendToSignTarget.addEventListener('click', (ev) => this.updateSignMetadataContainer());
		this.updateSignMetadataContainer();
	}

	updateSignMetadataContainer() {
		this.element.querySelector('#sign-metadata').classList.toggle('hidden', !this.checkSendToSignTarget.checked);
	}
}